import React from 'react'
import { Route, Switch } from 'react-router'
import ReportTrailerResults from './ReportTrailerResults'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportTrailerResults} />
    </Switch>
)

export default Components
